export default __webpack_public_path__ + "static/alfred_search_nm-3d3b2d65395f3a77dfa45e2cdc62da6e.png";